import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-topic-confirmation',
    templateUrl: './delete-topic-confirmation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeleteTopicConfirmationComponent {
    constructor(
        private readonly matDialogRef: MatDialogRef<DeleteTopicConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: { topicNames: string },
    ) { }

    onConfirmation(success: boolean): void {
        this.matDialogRef.close({ success });
    }
}
